<template>
  <div class="commodity">
    <navBar></navBar>
    <div class="back-container"></div>
    <div class="commodity-container">
      <div class="commodity-header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(name, navIdx) of form.ClassNameList" :key="navIdx">{{ name }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="commodity-wrapper">
          <div class="thumb-example" v-if="form.FileList && form.FileList.length > 0">
            <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
              <swiper-slide v-for="(file, index) of form.FileList"
                @click.native="imagePreview(imgUrlFilter(file.FileAddress))" :key="index" :style="{
                  'background-image':
                    'url(' + imgUrlFilter(file.FileAddress) + ')'
                }">
              </swiper-slide>
            </swiper>
            <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
              <swiper-slide v-for="(file, index) of form.FileList" :key="index" :style="{
                'background-image':
                  'url(' + imgUrlFilter(file.Thumbnail) + ')'
              }">
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="commodity-content">
          <div class="title">
            {{ form.ProductName }}
          </div>
          <div class="model">
            <div class="value">
              <span class="label">{{ $t("commodity.model") }}:</span>{{ form.ProductModel }}
            </div>
            <div class="value">
              <span class="label">{{ $t("commodity.customize") }}:</span>
              <span v-if="form.IsCustomizable">{{ $t("commodity.yes") }}</span>
              <span v-else>{{ $t("commodity.no") }}</span>
            </div>
            <div class="value">
              <span class="label">{{ $t("commodity.feature") }}:</span>{{ form.ProductFeatures }}
            </div>
          </div>
        </div>
        <div class="commodity-buttons">
          <el-button-group v-if="isAdmin">
            <el-button type="danger" size="small" @click="setShopShowcaseProduct(0)" v-if="form.IsSetProductShowcase">{{
              $t("commodity.removeShowcase") }}</el-button>
            <el-button type="primary" size="small" @click="setShopShowcaseProduct(1)" v-else>{{
              $t("commodity.setShowcase") }}</el-button>
          </el-button-group>
          <el-button-group v-else>
            <el-button class="basket-button" type="primary" @click="toBasket"><i class="el-icon-plus"></i><span>{{
              $t("B2B.toBasket") }}</span></el-button>
            <el-button class="quiry-button" type="warning" @click="toEnquiry(1)"><i
                class="el-icon-document"></i><span>{{ $t("B2B.inquiry") }}</span></el-button>
          </el-button-group>
        </div>
      </div>
      <div class="commodity-info" id="commodityInfo">
        <div class="info-title">
          <el-button-group>
            <el-button class="des-button" type="text" @click="toDescription">{{ $t("commodity.desc") }}</el-button>
            <el-button class="sup-button" type="text" @click="toEnquiry(2)">{{ $t("commodity.contact") }}</el-button>
          </el-button-group>
        </div>
        <div class="info-content">
          <div class="v-text" v-html="form.ProductDescription"></div>
        </div>
      </div>
    </div>
    <div class="supplier-container">
      <div class="info" @click="toBusiness">
        <div class="userImg">
          <img class="userImgIcon" :src="imgUrlFilter(form.CompanyLogo)" />
        </div>
        <div class="company">
          <div class="companyTitle">{{ form.CompanyName }}</div>
          <div class="companySubTitle">
            {{ form.BusinessProductClassList }}
          </div>
        </div>
        <div class="last-date">
          <div class="left">{{ $t("commodity.lastUpdate") }}</div>
          <div class="right">{{ form.LastUpdated }}</div>
        </div>
        <div class="profile">
          <div class="left">{{ $t("commodity.profile") }}</div>
          <div class="right long-text" :class="{ expanded: isTextExpanded }" ref="longText">{{ form.CompanyProfile }}
          </div>
          <div class="btns" v-if="showFoldBtn">
            <el-button type="text" size="mini" @click="toggleFold($event)">{{
              isTextExpanded ? $t("commodity.collapse") : $t("commodity.expand")
              }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <basket v-if="!isAdmin"></basket>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
import { SET_BASKET } from "../../store/mutation-types";

export default {
  name: "commodity",
  data() {
    return {
      isAdmin: false,
      form: {
        PId: "",
        ShopId: "",
        ProductName: "",
        ProductModel: "",
        ProductFeatures: "",
        ProductDescription: "",
        IsCustomizable: 0,
        IsSetProductShowcase: 0,
        ProductState: 0,
        ProductionTime: "",
        FileList: []
      },
      swiperOptionTop: {
        loopedSlides: 1, // looped slides should be the same
        effect: "fade",
      },
      swiperOptionThumbs: {
        loopedSlides: 1, // looped slides should be the same
        slidesPerView: 1,
        spaceBetween: 10,
        touchRatio: 0.5,
        slideToClickedSlide: true,
        virtualTranslate: true,
        width: 60
      },
      isTextExpanded: false,
      showFoldBtn: false
    };
  },
  mounted() {
    const { ProductNumber, IsAdmin } = this.$route.query;
    this.form.PId = ProductNumber || "";
    this.isAdmin = IsAdmin;
    if (this.form.PId) {
      this.getSupplierProductInfo().then(success => {
        if (success) {
          this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.$swiper;
            const swiperThumbs = this.$refs.swiperThumbs.$swiper;
            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
            this.swiperOptionTop.loopedSlides = this.form.FileList.length;
            this.swiperOptionThumbs.loopedSlides = this.form.FileList.length;
            this.swiperOptionThumbs.slidesPerView = this.form.FileList.length;
          });
        }
      });
    }
  },
  methods: {
    ...mapMutations([SET_BASKET]),
    ...mapActions({ getBasketProducts: "getBasket" }),
    toDescription() {
      var element = document.getElementById("commodityInfo");
      if (element) {
        var y = element.offsetTop - 85;
        window.scrollTo({
          left: 0,
          top: y,
          behavior: "smooth"
        });
      }
    },
    toggleFold(e) {
      e.stopPropagation();
      this.isTextExpanded = !this.isTextExpanded;
    },
    measureProfile() {
      this.$nextTick(() => {
        var longText = this.$refs.longText;
        if (!longText) return;
        // 收起时按 5 行截断（-webkit-line-clamp）；
        // 内容完整高度超过截断高度，说明超出 5 行，才显示展开按钮
        var clampedHeight = longText.clientHeight;
        longText.style.display = "block";
        var fullHeight = longText.scrollHeight;
        longText.style.display = "";
        this.showFoldBtn = fullHeight > clampedHeight + 2;
        if (!this.showFoldBtn) {
          this.isTextExpanded = false;
        }
      });
    },
    back() {
      if (window.history.length <= 2) {
        this.$router.replace("/");
      } else {
        this.$router.back(-1);
      }
    },
    toBasket() {
      var product = {
        PId: this.form.PId,
        ProductName: this.form.ProductName,
        ProductImage: this.form.FileList[0].FileAddress,
        ShopId: this.form.ShopId,
        CompanyName: this.form.CompanyName
      };
      this.getBasketProducts().then(res => {
        var prduct = res.products.find(p => p.PId == this.form.PId);
        if (prduct) {
          this.$message.error(this.$t("B2B.repeat"));
        } else {
          this.$message.success(this.$t("B2B.addSuccess"));
          this.$bus.$emit("showBasket", { show: true, activeTab: "first" });
        }
        this.SET_BASKET({ product: product, type: 1 });
      });
    },
    toEnquiry(type) {
      if (type == 1) {
        let routeUrl = this.$router.resolve({
          path: "/enquiry",
          query: { PIdList: this.form.PId, IsDetail: true }
        });
        window.open(routeUrl.href, "_blank");
      }
      if (type == 2) {
        let routeUrl = this.$router.resolve({
          path: "/enquiry",
          query: { ShopIdList: this.form.ShopId, IsDetail: true }
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    toBusiness() {
      let routeUrl = this.$router.resolve({
        path: "/business",
        query: { ShopId: this.form.ShopId }
      });
      window.open(routeUrl.href, "_blank");
    },
    imagePreview(image) {
      window.open(image);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getSupplierProductInfo() {
      return new Promise(resolve => {

        let param = {
          PId: this.form.PId
        };
        this.$api.product
          .getSupplierProductInfo(param)
          .then(res => {
            var data = res.data || {};
            this.form = data;
            this.measureProfile();

            resolve(true);
          })
          .catch(err => {

            this.$message.error(err.message);
          });
      });
    },
    setShopShowcaseProduct(state) {

      let param = {
        PId: this.form.PId,
        IsSetProductShowcase: state
      };
      this.$api.product
        .setShopShowcaseProduct(param)
        .then(() => {
          this.getSupplierProductInfo();
          this.$message.success(this.$t("B2B.success"));

        })
        .catch(err => {

          this.$message.error(err.message);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.commodity {
  background: rgb(246, 246, 246);

  .back-container {
    width: 15%;
    z-index: 11;
    display: inline-block;
    text-align: center;
    vertical-align: top;
    margin-top: 3%;

    .back-button {
      font-size: 14px;
    }
  }

  .commodity-container {
    min-height: 100vh;
    width: 50%;
    display: inline-block;

    .commodity-header {
      background: #fff;
      padding: 30px;

      .el-breadcrumb {
        font-size: 16px;
        margin-bottom: 20px;
      }

      .commodity-wrapper {
        width: 40%;
        display: inline-block;
        vertical-align: middle;

        .thumb-example {
          height: 400px;
          display: block;
          position: relative;

          .swiper {
            .swiper-slide {
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              background-color: #ffffff;
              cursor: pointer;

              .el-image {
                overflow: unset;
              }
            }

            &.gallery-top {
              height: 80%;
              width: 100%;
            }

            &.gallery-thumbs {
              position: absolute;
              bottom: 0%;
              left: 2.5%;
              width: 100%;
            }

            &.gallery-thumbs .swiper-wrapper {
              transform: unset !important;
            }

            &.gallery-thumbs .swiper-slide {
              height: 50px;
              border-width: 2px;
              border-style: solid;
              border-color: transparent;
              background-position: center;
              background-repeat: no-repeat;
            }

            &.gallery-thumbs .swiper-slide-active {
              height: 50px;
              border-width: 2px;
              border-style: solid;
              border-color: #fc5e08;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
        }
      }

      .commodity-content {
        width: 55%;
        margin-left: 5%;
        display: inline-block;
        vertical-align: middle;
        min-height: 300px;

        .title {
          font-size: 25px;
          font-weight: bold;
          padding-bottom: 20px;
          margin-bottom: 20px;
          border-bottom: 1px solid #707070;
        }

        .model {
          .value {
            margin-bottom: 20px;

            .label {
              color: #707070;
              margin-right: 30px;
            }
          }
        }
      }

      .commodity-buttons {
        margin-top: 30px;
        text-align: right;

        .basket-button {
          font-size: 16px;
          background: transparent;
          color: #999;
          border: none;
          margin-right: 10px;
          vertical-align: middle;
          display: inline-block;
        }

        .quiry-button {
          font-size: 20px;
          border-radius: 10px;
          padding: 10px 50px;
          background: linear-gradient(270.13deg, #f58603 0.13%, #fb3f04 99.91%);
          animation: buttonbg 3s infinite;
          vertical-align: middle;
          display: inline-block;

          span {
            margin-right: 10px;
          }
        }

        @keyframes buttonbg {
          0% {
            background: #fb5004;
          }

          50% {
            background: #fba000;
          }

          100% {
            background: #fb5004;
          }
        }
      }
    }

    .commodity-info {
      min-height: 50vh;
      background: #fff;
      margin-top: 30px;

      .info-title {
        padding: 0px 50px 0px 50px;
        border-bottom: 2px solid #f5f5f5;

        .des-button {
          font-size: 16px;
          color: #999;
          border-right: 2px solid #f5f5f5;
          padding-top: 20px;
          padding-bottom: 20px;
          padding-right: 50px;
        }

        .sup-button {
          margin-left: 50px;
          padding-top: 20px;
          padding-bottom: 20px;
          font-size: 16px;
        }
      }

      .info-content {
        padding: 30px;

        .v-text {
          overflow: scroll;
          min-height: 400px;
        }
      }
    }
  }

  .supplier-container {
    width: 20%;
    padding: 20px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;

    .info {
      padding: 20px;
      border-radius: 5px;
      box-shadow: 0 0 5px 0px #9b9b9b;
      background: #fff;

      .userImg {
        width: 30%;
        display: inline-block;
        text-align: center;
        vertical-align: middle;

        .userImgIcon {
          width: 50px;
          height: 50px;
          border-radius: 100px;
          box-shadow: 0 0 5px 0px #9b9b9b;
          object-fit: cover;
        }
      }

      .company {
        width: 65%;
        margin-left: 5%;
        display: inline-block;
        vertical-align: middle;

        .companyTitle {
          margin: 0;
          padding: 0;
          font-size: 14px;
          width: 100%;
          font-weight: bold;
        }

        .companySubTitle {
          margin: 0;
          padding: 0;
          margin-top: 10px;
          font-size: 12px;
          width: 100%;
          overflow: hidden;
          word-break: break-all;
        }
      }

      .last-date {
        width: 90%;
        margin: 30px auto 0px auto;
        font-size: 12px;

        .left {
          width: 50%;
          display: inline-block;
          vertical-align: middle;
          color: #a7a7a7;
        }

        .right {
          width: 50%;
          display: inline-block;
          vertical-align: middle;
          text-align: right;
        }
      }

      .profile {
        width: 90%;
        margin: 30px auto 0px auto;
        font-size: 12px;

        .left {
          display: inline-block;
          vertical-align: top;
          color: #a7a7a7;
          margin-bottom: 10px;
        }

        .right {
          display: inline-block;
          vertical-align: top;
        }

        .btns {
          text-align: right;
          .el-button--text{
            font-size: 14px !important;
          }
        }

        .long-text {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          overflow: hidden;

          &.expanded {
            display: block;
          }
        }
      }
    }
  }
}
</style>
